import { generateNumbers } from '@/utils/date';

/**
 * News
 */
export const newsValues = [
  600, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000,
].map((value) => ({
  text: value.toLocaleString(),
  value,
}));

/**
 * Group medical insurance
 */
export const groupMedicalInsuranceSelectValues = {
  A型: {
    0: [0, ...generateNumbers(3, 20)].map((value) => ({
      text: value !== 0 ? `${(value * 1000).toLocaleString()}円(${value}口)` : '-',
      value,
    })),
  },
  B型: {
    0: [0, ...generateNumbers(3, 20)].map((value) => ({
      text: value !== 0 ? `${(value * 600).toLocaleString()}円(${value}口)` : '-',
      value,
    })),
  },
  C型: {
    0: [0, ...generateNumbers(3, 20)].map((value) => ({
      text: value !== 0 ? `${(value * 1000).toLocaleString()}円(${value}口)` : '-',
      value,
    })),
  },
  D型: {
    0: [0, ...generateNumbers(3, 20)].map((value) => ({
      text: value !== 0 ? `${(value * 600).toLocaleString()}円(${value}口)` : '-',
      value,
    })),
  },
  E型: {
    0: generateNumbers(0, 10).map((value) => ({
      text: value !== 0 ? `${(value * 1500).toLocaleString()}円(${value}口)` : '-',
      value,
    })),
  },
  J型: {
    0: generateNumbers(0, 20).map((value) => ({
      text: value !== 0 ? `${(value * 100).toLocaleString()}万円(${value}口)` : '-',
      value,
    })),
  },
  K型: {
    0: generateNumbers(0, 20).map((value) => ({
      text:
        value !== 0
          ? `${value * 4}万円~${(value * 100).toLocaleString()}万円(${value}口)`
          : '-',
      value,
    })),
  },
  P型: {
    0: generateNumbers(0, 5).map((value) => ({
      text: value !== 0 ? `${(value * 100).toLocaleString()}万円(${value}口)` : '-',
      value,
    })),
  },
  Y型: {
    0: generateNumbers(0, 5).map((value) => ({
      text: value !== 0 ? `${(value * 10).toLocaleString()}万円/月(${value}口)` : '-',
      value,
    })),
  },
  Z型: {
    0: [
      { text: '-', value: 0 },
      { value: 1, text: '1億円' },
    ],
  },
  X型: {
    0: [
      { text: '-', value: 0 },
      { value: 1, text: '日本国内 無制限/日本国外 1億円' },
    ],
  },
  G型: {
    0: generateNumbers(0, 10).map((value) => ({
      text: value !== 0 ? `${(value * 1500).toLocaleString()}円(${value}口)` : '-',
      value,
    })),
  },
  M型: {
    0: generateNumbers(0, 20).map((value) => ({
      text: value !== 0 ? `${(value * 100).toLocaleString()}万円(${value}口)` : '-',
      value,
    })),
  },
  N型: {
    0: generateNumbers(0, 20).map((value) => ({
      text:
        value !== 0
          ? `${value * 4}万円~${(value * 100).toLocaleString()}万円(${value}口)`
          : '-',
      value,
    })),
  },
};

// All cards information
export const cardMocks = [
  {
    type: 'select',
    insuranseType:'maruki',
    tooltip: '試算したい保険種目にチェックをしてください。',
    notes: [
      'NEW(希)保険 試算にあたっての留意事項',
      '①こちらの保険料シミュレーションページは本人のみ試算可能です。',
      '②本人として加入資格を有する配偶者は、本人としてご加入ください(同一人が本人、配偶者のニつの資格でニ重に加入することはできません)。',
      '③保険料は概算保険料です。確定保険料は申込締切後に算出し、2027年1月1日から適用します。',
      '④ご加入できる方の範囲は、従業員ご本人、ご本人の配偶者・こどもです。詳しくはパンフレットをご参照ください。',
      '⑤退職後は新規加入や保険金額の増額はできません。',
      '⑥「(ご参考)月額換算」欄で表示している数値は「賞与払(半年分)保険料」を6で割って1か月あたりに換算したものです。',
      '⑦配偶者・こどもの試算も併せて行う場合、家族の保険料試算ページより試算いただけます。',
    ],
    identifier: '(登)C26E6071(2026.7.13)',
    title: 'NEW(希)保険',
    caption: '死亡・所定の高度障がい状態を保障',
    browse: '/group/products/individual/institution/maruki.html',
    browse2: '/cgi-bin/calc/seido_maruki.cgi',
    avatar: 'image/icon_maruki.svg',
    footer: {
      title: '合計保険料（賞与払）',
      subtitle: '試算にあたっての留意事項',
      about: null,
      money: null,
      subtitleAction: {
        type: 'open-dialog',
        payload: 'bonusCondition',
      },
    },
    items: [
      {
        title: '死亡保険金額',
        subtitle: '高度障がい保険金額',
        value: 1000,
        label: '万円',
        values: [...newsValues],
      },
    ],
  },
  {
    type: 'expan',
    insuranseType:'group',
    itemsOpen: [0, 4],
    notes: [
      '団体医療保険制度 試算にあたっての留意事項',
      '①こちらの保険料シミュレーションページは本人のみ試算可能です。',
      '②試算保険料は、2027年1月1日～2028年1月1日の契約に適用される保険料です。',
      '③ご加入できる方の範囲は、従業員ご本人、ご本人の配偶者・こども・両親・兄弟姉妹です(同居・扶養の制限はありません。)。',
      '④退職後は新規加入や保障の追加・増額はできません。',
      '⑤配偶者・こどもの試算も併せて行う場合、家族の保険料試算ページより試算いただけます。'
    ],
    title: '団体医療保険制度',
    caption: '病気・ケガ・災害等、万一のリスクに自ら備える',
    browse: '/group/products/individual/institution/group.html',
    browse2: '/cgi-bin/calc/seido_group.cgi',
    avatar: 'image/icon_group.svg',
    footer: {
      title: '合計保険料（月払い）',
      subtitle: '試算にあたっての留意事項',
      money: 1830,
      about: undefined,
      subtitleAction: {
        type: 'open-dialog',
        payload: 'bonusConditionInsurance',
      },
    },
    items: [
      {
        avatar: 'image/img_byoki.webp',
        title: '病気・ケガの保障',
        guaranteeAction: {
          type: 'open-dialog',
          payload: 'guaranteeIllness',
        },
        list: [
          {
            label: 'A型',
            insuranceFee: 0,
            sections: [
              {
                title: '入院保険金日額',
                value: 10,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['A型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                  insuranceType:'A'
                },
              },
              {
                title: '手術保険金',
                value: '手術の種類に応じて\n5～20万円',
                type: 'text',
              },
            ],
          },
          {
            label: 'B型',
            insuranceFee: 0,
            sections: [
              {
                title: '通院保険金日額',
                value: 5,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['B型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                  insuranceType:'B'
                },
              },
            ],
          },
          {
            label: 'C型',
            insuranceFee: 0,
            sections: [
              {
                title: `特定生活習慣病\n入院保険金日額`,
                value: 5,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['C型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                  insuranceType:'C'
                },
              },
              {
                title: `特定生活習慣病\n手術保険金`,
                value: '手術の種類に応じて\n5～20万円',
                type: 'text',
              },
            ],
          },
          {
            label: 'D型',
            insuranceFee: 0,
            sections: [
              {
                title: `特定生活習慣病\n退院後通院日額`,
                value: 5,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['D型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
        ],
      },
      {
        avatar: 'image/img_kega.webp',
        title: 'ケガの保障',
        subtitle: '交通事故によるケガも保障',
        guaranteeAction: {
          type: 'open-dialog',
          payload: 'guaranteeInjury',
        },
        list: [
          {
            label: 'E型',
            insuranceFee: 0,
            sections: [
              {
                title: '入院保険金日額',
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['E型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
              {
                title: '手術保険金',
                value: '手術の種類に応じて\n20～80万円',
                type: 'text',
              },
              {
                title: '通院保険金日額',
                value: '-',
                type: 'text',
              },
            ],
          },
          {
            label: 'J型',
            insuranceFee: 0,
            sections: [
              {
                title: '死亡保険金',
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['J型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
              {
                title: '後遺障害保険金',
                value: '-',
                type: 'text',
              },
            ],
          },
          {
            label: 'K型',
            insuranceFee: 0,
            sections: [
              {
                title: '後遺障害保険金',
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['K型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
        ],
      },
      {
        avatar: 'image/img_kaigo.webp',
        title: '介護保障',
        guaranteeAction: {
          type: 'open-dialog',
          payload: 'guaranteeLongTermCare',
        },
        list: [
          {
            label: 'P型',
            insuranceFee: 0,
            sections: [
              {
                title: '介護一時金',
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['P型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
        ],
      },
      {
        avatar: 'image/img_shotoku.webp',
        title: '収入減少に備える補償',
        guaranteeAction: {
          type: 'open-dialog',
          payload: 'guaranteeReduceIncome',
        },
        list: [
          {
            label: 'Y型',
            insuranceFee: 0,
            sections: [
              {
                title: `所得補償\n（月額補償額）`,
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['Y型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
        ],
      },
      {
        avatar: 'image/img_baiseki.webp',
        title: '日常のトラブルを補償',
        guaranteeAction: {
          type: 'open-dialog',
          payload: 'guaranteeDailyTrouble',
        },
        list: [
          {
            label: 'Z型',
            insuranceFee: 0,
            sections: [
              {
                title: `個人賠償責任補償\n（支払限度額）`,
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['Z型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
          {
            label: 'X型',
            insuranceFee: 0,
            sections: [
              {
                title: `個人賠償責任補償\n（支払限度額）`,
                value: 1,
                type: 'select-custom',
                values: [...groupMedicalInsuranceSelectValues['X型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
        ],
      },
      {
        avatar: 'image/img_kotsu.webp',
        title: '交通事故によるケガの保障',
        subtitle: '交通事故によるケガに限定した保障',
        guaranteeAction: {
          type: 'open-dialog',
          payload: 'guaranteeTrafficAccident',
        },
        list: [
          {
            label: 'G型',
            insuranceFee: 0,
            sections: [
              {
                title: `入院保険金日額`,
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['G型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
              {
                title: `手術保険金`,
                value: '-',
                type: 'text',
              },
              {
                title: `通院保険金日額`,
                value: '-',
                type: 'text',
              },
            ],
          },
          {
            label: 'M型',
            insuranceFee: 0,
            sections: [
              {
                title: `死亡保険金`,
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['M型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
              {
                title: `後遺障害保険金`,
                value: '-',
                type: 'text',
              },
            ],
          },
          {
            label: 'N型',
            insuranceFee: 0,
            sections: [
              {
                title: `後遺障害保険金`,
                value: 0,
                type: 'select-money',
                values: [...groupMedicalInsuranceSelectValues['N型'][0]],
                disabled: false,
                action: {
                  type: 'updateGroupMedicalInsurance',
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
